import React from 'react';
import '../App.css'; // Ensure this file contains the shared styles

const SaudiLaw = () => {
  return (
    <div className="container">
      {/* Introduction Section */}
      <div className="introduction">
        <h1 className="introduction-title">Saudi Law</h1>
        <p className="introduction-text">
          Saudi Arabia’s legal system is deeply rooted in Islamic law (Sharia) and royal decrees. 
          Unlike many countries, it does not have a codified constitution, with judicial rulings 
          based on interpretations of the Quran and the Sunnah. The system reflects the cultural 
          and religious framework of the nation.
        </p>
      </div>

      {/* Key Features Section */}
      <div className="row">
        <div className="column">
          <h3>Sharia Law</h3>
          <p>The primary source of legal rulings, based on the Quran and Hadiths.</p>
        </div>
        <div className="column">
          <h3>Royal Decrees</h3>
          <p>Legislative tools issued by the King to address specific legal and policy needs.</p>
        </div>
      </div>
      <div className="row">
        <div className="column">
          <h3>Islamic Judicial System</h3>
          <p>Courts that interpret and apply Sharia in civil, criminal, and personal status cases.</p>
        </div>
        <div className="column">
          <h3>Basic Law of Governance</h3>
          <p>The foundational document that outlines the principles of governance and law application.</p>
        </div>
      </div>
    </div>
  );
};

export default SaudiLaw;
